import {
  Box,
  CircularProgress,
  Grid,
  LinearProgress,
  styled,
  Typography,
} from "@mui/material";

import { MenuPopover } from "@/components";
import { ContainedButton } from "@/common";
import { tokens } from "@/tokens";

export const StyledContainedButton = styled(ContainedButton)(() => ({
  borderRadius: `${tokens.radius.sm} !important`,
  borderColor: tokens.border.default,
  width: "fit-content",
  flexShrink: 0,
  whiteSpace: "nowrap",
}));

export const StyledDeleteContainedButton = styled(ContainedButton)(() => ({
  borderRadius: `${tokens.radius.sm} !important`,
  borderColor: tokens.border.default,
  width: "fit-content",
  color: tokens.status.danger,
  flexShrink: 0,
  whiteSpace: "nowrap",
}));

export const LeftFilters = styled(Box)({
  display: "flex",
  gap: "12px",
});

export const RightFilters = styled(Box)({
  display: "flex",
  justifyContent: "right",
  gap: "12px",
});

export const StyledMenuPopover = styled(MenuPopover)(({ theme, sx }) => ({
  "& .MuiPaper-root": {
    width: 231,
    maxWidth: "unset",
    padding: theme.spacing(1),
    borderRadius: tokens.radius.lg,
    boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.08)",
    border: `1px solid ${tokens.border.default}`,
    "& .MuiTypography-root": {
      padding: "10px 16px 10px 16px",
      cursor: "pointer",
    },
    "& .MuiTypography-root:hover": {
      backgroundColor: tokens.bg.hover,
      color: tokens.brand.primary,
      borderRadius: 4,
    },
    "& .MuiList-root": {
      padding: 0,
    },
    "& .MuiListItem-root": {
      padding: theme.spacing(1, 2),

      "&:first-of-type": {
        backgroundColor: `${tokens.brand.primary}0A`,
        fontWeight: tokens.fontWeight.heavy,
      },
    },
    ...sx,
  },
}));

export const Backdrop = styled("div")(({ theme }) => ({
  position: "fixed",
  top: 0,
  left: 0,
  width: "100vw",
  height: "100vh",
  backgroundColor: "rgba(0, 0, 0, 0.15)",
  zIndex: theme.zIndex.modal - 1, // Ensure it stays behind the Popover
}));

export const StyledProcessBox = styled(Box)(({ theme }) => ({
  display: "flex",
  flexDirection: "column",
  alignItems: "flex-start",
  justifyContent: "center",
  padding: theme.spacing(2),
  borderRadius: tokens.radius.md,
  boxShadow: theme.shadows[1],
  backgroundColor: tokens.bg.surface,
  width: "100%",
  marginBottom: theme.spacing(3),
  "& a": {
    color: tokens.brand.primary,
    textDecoration: "unset",
  },
  "& a:hover": {
    textDecoration: "underline",
  },
}));

export const StyledLoaderText = styled(Box)(({ theme }) => ({
  display: "flex",
  alignItems: "center",
  marginBottom: theme.spacing(1),
}));

export const GradientCircularProgress = styled(CircularProgress)({
  width: "16px",
  height: "16px",
  "svg circle": { stroke: "url(#my_gradient)" },
});

export const BodyText = styled(Typography)(({ theme }) => ({
  marginBottom: theme.spacing(2),
}));

export const ProgressContainer = styled(Box)({
  display: "flex",
  alignItems: "center",
  width: "100%",
});

export const StyledLinearProgress = styled(LinearProgress)(({ theme }) => ({
  flexGrow: 1,
  marginRight: theme.spacing(2),
  height: 8,
  borderRadius: 2,
  backgroundColor: tokens.scrollbar.track,
}));

export const PercentageText = styled(Typography)({
  color: "#2E2C34",
});

export const StyledHeadeButtons = styled(Grid)(({ theme }) => ({
  marginBottom: theme.spacing(1),
}));
